import React from 'react'

import {TopNav, SideNav, SideNavItem, useSideNav} from '../UI/navigation/index.js'
import BranchSelector, {branchIcon} from '../branches/BranchSelector.js'
import {navOffset, setNavPosition, showNavPositionSwitch} from './navPosition.js'

// The branch selector as a row of the side nav, its menu keeps the rail expanded while open
function SideBranchSelector({branches}) {
    const {onMenuToggle} = useSideNav()

    return (
        <BranchSelector {...branches} placement='right' popoverStyle={{marginLeft: 8}} onToggle={onMenuToggle}>
            {(label) => <SideNavItem icon={branchIcon} title={label} hasPopup trailing={<i className='mdi mdi-chevron-right' />} />}
        </BranchSelector>
    )
}

/**
 * The navigation of a layout (planner, customer, admin), rendered from its AppNavigation (types.ts) as the bar at the
 * top or the rail at the left (navPosition.ts). The account menu has the item that switches between the two (while showNavPositionSwitch). Give
 * the layout layoutStyle(position) and its page layoutContentStyle(position).
 */
export default function AppNav({navigation, position, branding, history}) {
    const {branches} = navigation

    const side = position === 'side'

    const withSwitch = showNavPositionSwitch && {
        ...navigation,
        account: {
            ...navigation.account,
            // Before Uitloggen, the last item
            links: [
                ...navigation.account.links.slice(0, -1),
                side ?
                    {key: 'navPosition', title: 'Navigatie boven', icon: 'mdi mdi-dock-top', onClick: () => setNavPosition('top')} :
                    {key: 'navPosition', title: 'Navigatie links', icon: 'mdi mdi-dock-left', onClick: () => setNavPosition('side')},
                ...navigation.account.links.slice(-1)
            ]
        }
    }

    if (side) {
        return (
            <SideNav
                navigation={withSwitch || navigation}
                branding={branding}
                history={history}
                endSlot={branches && <SideBranchSelector branches={branches} />}
            />
        )
    }

    return (
        <TopNav
            navigation={withSwitch || navigation}
            branding={branding}
            history={history}
            endSlot={branches && <BranchSelector {...branches} />}
        />
    )
}

/** Room for the navigation around the page: below the top bar or next to the side rail */
export function layoutStyle(position) {
    const {top, left} = navOffset(position)
    return {paddingTop: top, paddingLeft: left}
}

/**
 * Style of the page next to the side rail: its own stacking context, so things in the page with a z-index (map
 * controls, the vehicle panel) stay below the rail when it expands over the page. The top bar doesn't overlap the
 * page, there the page keeps lying in the stacking context of the layout like before.
 */
export function layoutContentStyle(position) {
    return position === 'side' ? {isolation: 'isolate'} : {}
}
